// extracted by mini-css-extract-plugin
export default {"Timestamp":"Timestampmv6iXgTmR2h6"};